import { IUser } from "@shared/mirage/core/contracts/IUser";
import { UserPermission } from "@shared/mirage/core/contracts/User";
import { IUserTablePreferences } from "@shared/mirage/services/IUserPreferencesService";
import { StateCreator } from "zustand";

export interface UserStore extends Partial<IUser> {
    id: number;
    permissions?: UserPermission[];
    expiryDate?: Date;
    sessionTimeoutBuffer?: number;
    subModules?: string[];
    superSetUrl?: string;
    inbox?: boolean;
    groupId?: number | null;
}

export interface UserPreferencesStore {
    entityTables: Record<string, IUserTablePreferences>;
}

export interface UserSlice {
    user: UserStore;
    userPreferences: UserPreferencesStore;
    setUser: (user: UserStore) => void;
    updateUser: (user: Partial<UserStore>) => void;
    setUserPreferences: (preferences: UserPreferencesStore) => void;
    updateEntityTablePreferences: (tableName: string, preferences: IUserTablePreferences) => void;
    resetUser: () => void;
}

const initialUserState: UserStore = {
    id: 0,
};

const initialUserPreferencesState: UserPreferencesStore = {
    entityTables: {},
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (set) => ({
    user: initialUserState,
    userPreferences: initialUserPreferencesState,

    setUser: (user) => set({ user }),

    updateUser: (partialUser) =>
        set((state) => ({
            user: { ...state.user, ...partialUser },
        })),

    setUserPreferences: (preferences) => set({ userPreferences: preferences }),

    updateEntityTablePreferences: (tableName, preferences) =>
        set((state) => ({
            userPreferences: {
                ...state.userPreferences,
                entityTables: {
                    ...state.userPreferences.entityTables,
                    [tableName]: preferences,
                },
            },
        })),

    resetUser: () =>
        set({
            user: initialUserState,
            userPreferences: initialUserPreferencesState,
        }),
});
